// Sentry initialization should be the first import
import '../instrument';

// Group related imports
// React and ReactDOM
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Routing
import { BrowserRouter } from 'react-router';

// AWS
import { Amplify } from 'aws-amplify';
import amplifyConfig from '../amplify.config.ts';
import sentryConfig from '../sentry.config';

// Query Client
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './utils/trpc';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// App Component
import App from './App.tsx';

// Configure external services
Amplify.configure(amplifyConfig);

// Create root with Sentry error hooks
const root = createRoot(document.getElementById('root')!, sentryConfig);

// Render app
root.render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-left"
        />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
